import { render, staticRenderFns } from "./DocumentAction.vue?vue&type=template&id=2684dcc0&"
import script from "./DocumentAction.vue?vue&type=script&lang=js&"
export * from "./DocumentAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports